import { useEffect, useRef } from 'react';
import MembershipInfoEdit from './MembershipInfoEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import { LoggerTypes } from '../../../bmCommonLibrary/bmDeclareTypes';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'membershipInfo';

    useEffect(() => {
    }, []);

    //表头
    const columnsHead = [
        {
            title: '姓名',
            dataIndex: 'membershipName'
        },
         {
            title: '公司名',
            dataIndex: 'companyName'
        },
        {
            title: '手机',
            dataIndex: 'contactNumber'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '会员信息',
        apiId,
        columns,
        serviceId: 'business',
        editOptions: {
            Editor: MembershipInfoEdit
        },
        displayOptions: {
            loggerProps: {
                showSingleLogger: true,
                LoggerTypes,
                loggerTypeId: 'MEMBERSHIP'
            }
        }
    };

    return (<WebUniversal {...extendProps} ref={ref} />)
}

export default WebComponent;
